import ContentFeatureUI, {
  Props as UIProps,
} from '@interflora/ui-components/build/components/ContentFeature/ContentFeature'
import React from 'react'
import { useAnalytics } from 'hooks/useAnalytics'
import { useLoaded } from '@interflora/ui-components/build/components/MainContent/useComponentLoading'

type Props = UIProps

const ContentFeature = (props: Props) => {
  const analytics = useAnalytics()

  const contentFeatureAnalytics = (linkText: string) => {
    analytics.contentFeatureLinkTextAnalytics(linkText)
  }

  useLoaded(props)

  return <ContentFeatureUI {...props} contentFeatureAnalytics={contentFeatureAnalytics} />
}

export default ContentFeature
